/*
 * Header login / account links: go straight to the page instead of opening
 * an app's slide-out panel. Runs in the capture phase on window, so it fires
 * before click handlers that apps attach to the document or the link itself.
 */
(function () {
  function findAccountLink(target) {
    if (!target || !target.closest) return null;
    return target.closest(
      '#primaryHeader a#customer_login_link,' +
      '#primaryHeader a[href^="/account/login"],' +
      '#primaryHeader a[href="/account"],' +
      '#primaryHeader a[href^="/account?"]'
    );
  }

  window.addEventListener('click', function (e) {
    var link = findAccountLink(e.target);
    if (!link) return;

    // Let ctrl/cmd/shift/middle-click open a new tab as normal
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#' || href.indexOf('javascript:') === 0) {
      href = link.id === 'customer_login_link' ? '/account/login' : '/account';
    }

    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = href;
  }, true);
})();
